import * as React from 'react';
import User from "../../Models/User/User";

import './UserView.css';

interface IProps {
    user: User;
}

const UserView: React.SFC<IProps> = (props) => {
    return (
        <li className="user"><a href={"/profile/" + props.user.userLinkName} target="_blank">{props.user.username}</a></li>
    );
}

export default UserView; 